import { combineReducers } from 'redux'

import { templatesReducer, CurrentTemplateReducer } from 'apps/templates/actions/templatesActions'
import { CurrentInstalledTemplateReducer } from 'apps/templates/slices/currentInstalledTemplate'
import { installedTemplatesReducer } from 'apps/templates/slices/installedTemplates'
import { templateInstallationsReducer } from 'apps/templates/slices/templateInstallations'

import draft from './draft'
import installation from './templateInstallation'

export default combineReducers({
  draft,
  list: templatesReducer,
  installed: installedTemplatesReducer,
  currentInstalled: CurrentInstalledTemplateReducer,
  current: CurrentTemplateReducer,
  installation,
  templateInstallations: templateInstallationsReducer,
})
